import { Modal } from "@ctsu/react-ctsu-ui";
import React, { useState } from "react";
import text from "protocol-setup/constants/text";
import { titleAndAria } from "protocol-setup/constants/errorMessages";
import ProtocolSetupForm from "./ProtocolSetupForm";

const NewProtocolSetupForm = ({ leadGroupLov }) => {
  const [openModal, setModal] = useState(false);
  
  return (
    <>
      <button
        type="button"
        onClick={() => setModal(!openModal)}
        className="btn turquoise"
        title={titleAndAria.addNewProtocolSetupRequest}
      >
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="plus"
          className="svg-inline--fa fa-plus fa-w-14 ml-n1"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
          ></path>
        </svg>
        {text.browser.requestBrowser.newProtocolSetupForm.buttonLabel}
      </button>
      {  openModal && 
      (
        <Modal
          id="Protocol_Setup_Request"
          modalTitle={text.browser.requestBrowser.newProtocolSetupForm.modalTitle}
          onClose={() => setModal(false)}
          showCloseBtn={false}
          modalSize="sm"
          modalMaxHeight
        >
          <div>
            <p className="mt-0">
              {text.browser.requestBrowser.newProtocolSetupForm.description1}
            </p>
            <p>
              {text.browser.requestBrowser.newProtocolSetupForm.description2}
            </p>
          </div>
          <ProtocolSetupForm
            leadGroupLov={leadGroupLov}
            onClose={() => setModal(false)}
          />
        </Modal>
      )}
    </>
  );
};



export default NewProtocolSetupForm;